import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody } from "@aix/ui"
import { useAtomValue } from "jotai"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import FakeTextTemplate from "~/components/Templates/FakeTextTemplate"
import AppLayout from "~/layouts/AppLayout"
import CustomHead from "~/components/SEOHead/CustomHead"
import { navStyleAtom } from "~/context/jotai"
import { getPageSEO } from "~/utils/seo"

const CreateVideoPage = () => {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "Fake Text" }]
  const fakeTextSEO = getPageSEO("templates/fake-text")
  const navStyle = useAtomValue(navStyleAtom)

  return (
    <>
      <CustomHead
        title={fakeTextSEO.title}
        description={fakeTextSEO.description}
        keywords={fakeTextSEO.keywords}
        pageType={fakeTextSEO.pageType}
        url="https://vidmax.ai/templates/fake-text"
      />

      {navStyle !== "twoTier" && <BreadcrumbBanner items={breadcrumbItems} />}

      <AixContentBody className="sm:[--content-max-width:500px] md:[--content-max-width:700px] xl:[--content-max-width:960px]">
        <FakeTextTemplate />
      </AixContentBody>
    </>
  )
}

function CreateVideoPageWrapper() {
  return (
    <AppLayout>
      <CreateVideoPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/templates/fake-text")({
  component: CreateVideoPageWrapper,
})
